import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// v3.99d.341ad — register the Web Push service worker at boot.
// Failure is silent so unsupported browsers (older iOS Safari, etc.)
// don't produce console noise.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
